/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Finance } from './';
import {
    FinanceFromJSON,
    FinanceFromJSONTyped,
    FinanceToJSON,
} from './';
import type { FinanceType } from './';
import {
    FinanceTypeFromJSON,
    FinanceTypeFromJSONTyped,
    FinanceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Budget
 */
export interface Budget extends Finance {
    /**
     * 
     * @type {number}
     * @memberof Budget
     */
    budget: number;
}

/**
 * Check if a given object implements the Budget interface.
 */
export function instanceOfBudget(value: object): value is Budget {
    if (!('budget' in value) || value['budget'] === undefined) return false;
    return true;
}

export function BudgetFromJSON(json: any): Budget {
    return BudgetFromJSONTyped(json, false);
}

export function BudgetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Budget {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...FinanceFromJSONTyped(json, ignoreDiscriminator),
        'budget': json['budget'],
    };
}

export function BudgetToJSON(value?: Budget | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...FinanceToJSON(value, true),
        'budget': value['budget'],
    };
}

